import { MULTI_SELECT_KEYS } from "../../constants"

/**
 * Converts the current filter selections into URLSearchParams.
 * Omits parameters that match their default values (data bounds).
 */
export function getParamsFromSelections(selections, minCt, maxCt) {
    const params = new URLSearchParams()
    
    if (selections.searchQuery) params.set('q', selections.searchQuery)
    
    if (selections.ct.fromValue !== undefined && selections.ct.fromValue !== minCt) {
        params.set('ct_from', selections.ct.fromValue)
    }
    if (selections.ct.toValue !== undefined && selections.ct.toValue !== maxCt) {
        params.set('ct_to', selections.ct.toValue)
    }

    MULTI_SELECT_KEYS.forEach(key => {
        if (selections[key] && selections[key].size > 0) {
            params.set(key, Array.from(selections[key]).join(','))
        }
    })

    if (selections.selectedStocks && selections.selectedStocks.size > 0) {
        params.set('stock_no', Array.from(selections.selectedStocks).join(','))
    }

    return params
}

/**
 * Initializes selections state from URLSearchParams and the provided data bounds.
 */
export function getSelectionsFromParams(data, params) {
    const minCt = data.length > 0 ? Math.min(...data.map(d => Number(d.ct))) : 0.00
    const maxCt = data.length > 0 ? Math.max(...data.map(d => Number(d.ct))) : 3.00

    const urlCtFrom = params.get('ct_from')
    const urlCtTo = params.get('ct_to')

    const state = {
        ct: {
            fromValue: urlCtFrom !== null ? Number(urlCtFrom) : minCt,
            toValue: urlCtTo !== null ? Number(urlCtTo) : maxCt
        },
        searchQuery: params.get('q') || ''
    }

    MULTI_SELECT_KEYS.forEach(selector => {
        const urlValues = params.get(selector)
        if (urlValues) {
            const optionsSet = new Set(data.map(d => d[selector]))
            state[selector] = new Set(urlValues.split(',').filter(v => optionsSet.has(v)))
        } else {
            state[selector] = new Set()
        }
    })

    const urlStocks = params.get('stock_no')
    if (urlStocks) {
        state.selectedStocks = new Set(urlStocks.split(',').filter(v => v !== ''))
    } else {
        state.selectedStocks = new Set()
    }

    return state
}
